import videoJsonConfig from "../../../../Settings/global/video.json";
//import jwplayer from "../../../libs/jwplayer-7.6/jwplayer";
import "../../../libs/jwplayer-8.1.11/jwplayer";
var jwplayer = window.jwplayer;
//jwplayer.key = "rgP22Py/jYzmXcg4SWRmPOsIvMZfZ8yx/nnong==";
 jwplayer.key = "tKafT/E+mI/GayzyW3yBtpLleVrJr9bZ0SCgLw==";
//window.jwplayer = jwplayer;

export function render(nodo, video_id, multimediofileId, multimedioJWKey, multimediofileJWKey, videoDestacado, showAds, autoPlay, arrayTags, videoTag_Home, contenedor, titulo) {
    let nodoId = "jwVideo" + multimediofileId,
        playlistUrlBase = videoJsonConfig.playlistUrlBase,
        settings = videoJsonConfig.settings; //new LN.conf.video.settings();

    if (multimedioJWKey) {
        /* Es una playlist */
        settings.playlist = playlistUrlBase + multimedioJWKey + ".xml";
        //settings.skin = undefined;
    } else if (multimediofileJWKey) {
        /* Es un video */
        settings.playlist = playlistUrlBase + multimediofileJWKey + ".xml";
    }

    //TODO: SHARING FUNCTION (<iframe>)---------------------------------------------------------------------------------------------------
    //if (video_id != '' && settings.sharing.code ){ 
    //    settings.sharing.code = '<iframe src="' + document.location.origin + '/herramientas/modal-video/-multimedio_id=' + video_id + '" width="100%" height="650"/>'
    //}

    //if (settings.sharing.link && settings.sharing.link.indexOf('http://') != 0)
    //    settings.sharing.link = document.location.origin + settings.sharing.link;
    //-------------------------------------------------------------------------------------------------------------------------------------

    //TODO: VER EL TEMA DE LOS ADS EN LOS VIDEOS------------------------------------------------------------------------------------------
    if ((showAds != undefined && showAds == 0) || (window.innerWidth > 1359 && window.LN.tipoPaginaBanner == "home"))
    {
        settings.advertising = {};
    }
    else {
        settings.advertising.schedule = ads.getVideoURL("vmap");
        //settings.advertising.schedule.postroll.tag = window.JW.ads.getVideoURL("vast","postroll");   
    }

    nodo.innerHTML += '<div id="' + nodoId + '"></div>';

    if (autoPlay === true) {
        settings.autostart = true;
    } else {
        settings.autostart = false;
    }
    const player = jwplayer(nodoId).setup(settings);
    //TODO: GOOGLE ANALYTICS---------------------------------------------------------------------------------------------------
    //let eventosParametro = video_id.toString();
    //contenedor.toString();


    player.on('adPlay', function () {
        if (isInDatalayerEvent(video_id, 'videoPlay', dataLayer))
        dataLayer.push({ 'event': 'videoPlay', 'videoName': titulo, 'videoTags': arrayTags, 'videoID': video_id });
    });
    
    player.on("play", function (data) {
        //if (data.oldState === "buffering" && player.getPosition() === 0 && isInDatalayerEvent(video_id, dataLayer)) {
        if (isInDatalayerEvent(video_id, 'videoPlay', dataLayer)) {
            dataLayer.push({ 'event': 'videoPlay', 'videoName': titulo, 'videoTags': arrayTags, 'videoID': video_id });
        }
    });
    
    player.on("time", function (event) {
        let percent = Math.floor(100 * event.position / event.duration);
        switch (percent) {
            case 25:
                if (isInDatalayerEvent(video_id, '25', dataLayer)) {
                    dataLayer.push({ 'event': '25', 'videoName': titulo, 'videoTags': arrayTags, 'videoID': video_id });
                }
                break;
            case 50:
                if (isInDatalayerEvent(video_id, '50', dataLayer)) {
                    dataLayer.push({ 'event': '50', 'videoName': titulo, 'videoTags': arrayTags, 'videoID': video_id });
                }
                break;
            case 75:
                if (isInDatalayerEvent(video_id, '75', dataLayer)) {
                    dataLayer.push({ 'event': '75', 'videoName': titulo, 'videoTags': arrayTags, 'videoID': video_id });
                }
                break;
        default:
        }
    });
    //player.on("complete", function () {
    //    ga("send", "event", "Video-Nativo", "complete", eventosParametro, { 'dimension10': contenedor });
    //});
    //-------------------------------------------------------------------------------------------------------------------
    player.on("complete", function () {
        if (dataLayer) {
            dataLayer.push( {'event':'videoComplete', 'videoName':titulo, 'videoTags':arrayTags , 'videoID': video_id });
        }
    });

    //PLAYLIST-----------------------------------------------------------------------------------------------------------
    if (multimedioJWKey) {
        /* Dar formato a la playlist */
        player.on("ready",
            function() {
                let html = "";
                const playlist = player.getPlaylist();
                //console.log(playlist.length);
                //if (playlist.length > 1) {
                if(playlist.length > 1)
                {
                    for (let index = 0; index < playlist.length; index++) {
                        html += "<a href='javascript:void(0)' onclick='javascript:playVideoPlayList(\"" + nodoId + "\", " + index + ")'>";
                        html += "<span class='play-list icon-play'></span>" + "<p>" + playlist[index].title + "</p>";
                        html += "</a>";
                    }    
                
                    const elemDiv = document.createElement("div");
                    elemDiv.setAttribute("class", "playlist-generico");
                    elemDiv.setAttribute("id", "PlayList-" + video_id);
                    document.getElementById("videoContainerVideo-" + video_id).appendChild(elemDiv);

                    document.getElementById("PlayList-" + video_id).innerHTML = html;
                }
                //}
            });
    }


    if (dataLayer) {
        //indica que se dibujo un video
        dataLayer.push( {'event':'videoDisplay', 'videoName':titulo, 'videoTags':arrayTags , 'videoID': video_id });
    }
    
    //-------------------------------------------------------------------------------------------------------------------
    //  ga('send', 'event', 'Video-Nativo', 'Embed', eventosParametro, { 'dimension10': contenedor });
    return nodo;
    
   
}

function isInDatalayerEvent(video_id, event, datalayer) {
    let array = datalayer.filter(function (element) {
        if (element['event'] == event && element['videoID'] == video_id)
        return element;
    });

    return array.length > 0 ? false : true;
}

//function areAdsShowed(settings, showAds) {
//    if (showAds != undefined && showAds == 0)
//    {
//        settings.advertising = undefined;
//    }
//    else
//    {
//        settings.advertising.schedule.myAds.tag = ads.getVideoURL("vast", "preroll");
//        settings.advertising.schedule.postroll.tag = ads.getVideoURL("vast","postroll");   
//    }

//    return settings;
//}

function playVideoPlayList (nodoId, index) {
    const player = jwplayer(nodoId);
    player.playlistItem(index);
}
window.playVideoPlayList = playVideoPlayList;


// WEBPACK FOOTER //
// ./Statics/scripts/common/jwplayer/jwplayerRender.js